function isValidUrl(string) {
  try {
    new URL(string)
    return true
  } catch {
    return false
  }
}

export default function RedirectAction({ actionId }) {
  const action = useSel(s => s.taker.flow.actions.find(a => a.id === actionId) || {})
  const { config } = action

  const redirectUrl = config?.redirectUrl || window.ENV?.CLIENT_BRAND?.custom_homepage_url

  const isValid = redirectUrl && isValidUrl(redirectUrl)

  useEffect(() => {
    if (isValid) {
      window.location.href = redirectUrl
    }
  }, [isValid, redirectUrl])

  if (!redirectUrl) {
    return <div>Unable to redirect — homepage URL has not been configured in brand settings</div>
  }

  if (!isValid) {
    return <div>Invalid redirect URL</div>
  }

  return <div>
    Redirecting...
  </div>
}
